<template>
  <div>
    <jd-form
      class="mb16"
      :formData="searchInfo"
      :form-info="getCalendarCheckInFormInfo"
      @search="getParticipateRecord"
      ref="funGameRecordRef"
    ></jd-form>
    <div style="margin-bottom: 16px" class="flex-between">
      <jd-button :disabled="!dataSource.length" @click="addCrowd"
        >按查询结果生成人群</jd-button
      >
      <jd-button type="text" :disabled="!dataSource.length" @click="exportAll">导出</jd-button>
    </div>
    <div class="new-table-box">
      <jd-table
        v-loading="loading"
        :tableData="dataSource"
        :tableInfo="tableInfo"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        row-key="id"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: total,
        }"
        @handlePage="handleCurrentChangeAll"
      >
        <template #sellerLinkNameSlot="{ row }">
          <div>{{ row.sellerLinkName || "-" }}</div>
        </template>
        <template #cumulativeDaySlot="{ row }">
          <jd-button type="blueText" @click="handleToTab('clockInDetails')">{{ row.cumulativeDay }}</jd-button>
        </template>
        <template #cumulativeGetReSignNumSlot="{ row }">
          <jd-button type="blueText" @click="handleToTab('twelve')">{{ row.cumulativeReSignNum }}</jd-button>
        </template>
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :activityType="rowData.activityType"
      :source="6"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      :searchForm="crowCondition"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import crowdDialog from "../../crowd-Dialog.vue";
import {
  getCalendarCheckInJoinRecord,
  getCalendarCheckInJoinRecordExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  components: {
    crowdDialog
  },
  props: {
    inputInfo: {
      type: Array,
      default: () => [],
    },
    rowData: {
      type: Object,
      default: () => {},
    },
    levelMap: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      total: 0,
      formList: {
        size: 10,
        current: 1,
      },
      dataSource: [],
      loading: false,
      searchInfo: {
        nickName: "",
        pin: "",
        sellerLinkId: "",
        firstCheckInStartTime: "",
        firstCheckInEndTime: "",
        latestCheckInStartTime: "",
        latestCheckInEndTime: ""
      }, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: true, // 是否有默认值
      defaultValueText: "参与记录", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      crowCondition: {},
      tableInfo: [
        {
          prop: "memberNick",
          label: "用户昵称",
        },
        {
          prop: "chaosPin",
          label: "用户pin（加密）",
        },
        {
          prop: "sellerLinkName",
          slot: "sellerLinkNameSlot",
          label: "投放渠道",
        },
        {
          prop: "firstSignTime",
          label: "首次打卡时间",
        },
        {
          prop: "lastSignTime",
          label: "最新打卡时间",
        },
        {
          prop: "cumulativeDay",
          label: "累计打卡天数",
          slot: "cumulativeDaySlot",
        },
        {
          prop: "sequenceDay",
          label: "连续打卡天数",
        },
        {
          prop: "cumulativeReSignNum",
          label: "累计获取补签卡数",
          slot: "cumulativeGetReSignNumSlot",
        },
        {
          prop: "remainReSignNum",
          label: "剩余补签卡张数",
        },
      ],
    };
  },
  computed: {
    getCalendarCheckInFormInfo: {
      get() {
        return this.inputInfo;
      },
      set(val) {
        this.$emit("update:inputInfo", val);
      },
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleToTab(val) {
      this.$emit("handleToTabCb", val);
    },
    handleCurrentChangeAll(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
     getParticipateRecord(params) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.searchInfo.nickName = params.nickName ? params.nickName : "";
      this.searchInfo.pin = params.pin ? params.pin : "";
      this.searchInfo.sellerLinkId = params.sellerLinkId
        ? params.sellerLinkId
        : "";
      this.searchInfo.firstSignStartTime = params.firstSignStartTime ? params.firstSignStartTime : "";
      this.searchInfo.lastSignStartTime = params.lastSignStartTime ? params.lastSignStartTime : "";
      this.searchInfo.lastSignEndTime = params.lastSignEndTime ? params.lastSignEndTime : "";
      this.searchInfo.lastSignEndTime = params.lastSignEndTime ? params.lastSignEndTime : "";
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        this.crowCondition = {
          ...params,
          hdSource: 6,
          activityType: this.rowData.activityType,
        };
        const res = await getCalendarCheckInJoinRecord(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(remark = "") {
      let params = {
        ...this.formList,
        ...this.searchInfo,
        activityId: this.rowData.id,
        remark,
      };
      this.formLoading = true;
      getCalendarCheckInJoinRecordExport(params).then((res) => {
        this.formLoading = false;
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
